import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { isNonEmptyInput } from '~/infra/utils';
export const emptyExpiryError = 'Please enter a valid card expiry date';
export const emptyCvvError = 'Please enter a valid CVV';
export const emptyCardNumberError = 'Please enter a valid card number';
export const getInitialValueState = ()=>({
        value: '',
        error: null,
        pristine: true,
        touched: false
    });
export const getInitialStripeValue = function getInitialStripeValue() {
    let errorMessage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    return {
        touched: false,
        valid: false,
        errorMessage
    };
};
export function mapStripeErrorToMessage(error) {
    switch(error.code){
        case 'card_declined':
            {
                switch(error.decline_code){
                    case 'invalid_account':
                        return 'Credit card connection failed. The card, or account the card is connected to, is invalid. Contact your card issuer or connect a different payment method.';
                    case 'transaction_not_allowed':
                    case 'do_not_honor':
                        return 'The card was declined. Contact your card issuer to find out why it was declined or connect a different payment method.';
                    default:
                        return null;
                }
            }
        case 'incorrect_cvc':
        case 'invalid_cvc':
            return "The card's security code is incorrect. Check the card's security code or use a different card.";
        case 'setup_intent_authentication_failure':
            return "The provided credit card has failed authentication. Please check the card's information or connect a different payment method.";
        case 'incorrect_number':
            return "The card number is incorrect. Check the card's number or use a different card.";
        default:
            return null;
    }
}
export const stripeStateReducer = (state, action)=>{
    const { type, errorMessage = '' } = action;
    switch(type){
        case 'error':
            return _object_spread_props(_object_spread({}, state), {
                valid: false,
                errorMessage
            });
        case 'valid':
            return state.valid ? state : _object_spread_props(_object_spread({}, state), {
                valid: true
            });
        case 'blur':
            return state.touched ? state : _object_spread_props(_object_spread({}, state), {
                touched: true
            });
        default:
            return state;
    }
};
export function validateNameOnCard(value) {
    return isNonEmptyInput(value) ? '' : 'Please specify the name on the card.';
}
export function validateZipCode(value) {
    let minLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    const trimmed = value.trim();
    let error = '';
    if (!isNonEmptyInput(trimmed)) {
        error = 'Please specify the ZIP code.';
    } else if (minLength > 0 && trimmed.length < minLength) {
        error = 'Please enter a valid 5-digit ZIP Code';
    }
    return error;
}
